import { useEffect, useState } from "react";
// import GroupSerach from "../components/GroupSerach";
import { getGraficOptions } from "../Axios/searchoff";
import { Link } from 'react-router-dom';

const GroupPage = () => {

    const [graficToday, setGraficToday] = useState(false);
    const [graficTomorrow, setGraficTomorrow] = useState(false);

    useEffect(()=>{
        window.scrollTo(0,0);
      }, [])

    useEffect(()=>{
        let active = false;
        getGraficOptions( 'pw_gpv_image_today').then((response)=>{
            const [today]= response['hydra:member'];
            if(!active) {
                setGraficToday(today);
            }
        }).catch((err) => {
            console.log(err);
            setGraficToday(false);
        })
    
        getGraficOptions( 'pw_gpv_image_tomorrow').then((response)=>{
            const [tomorrow]= response['hydra:member'];
            if(!active) {
                setGraficTomorrow(tomorrow);
            }
        }).catch((err) => {
            console.log(err);
            setGraficTomorrow(false);
        })

        return () => {
            active = true;
        };
    }, [])  

    return (
        <section className="power-off">
            <div className="container">
            <div className="content" >
                <div className="group-images">
                    {(graficTomorrow && graficTomorrow?.value?.length > 1) &&
                        <Link target='_blank' to={process.env.REACT_APP_SERVER_SEARCH_URL + graficTomorrow.value}>
                            <img height={265} width={1038} src={process.env.REACT_APP_SERVER_SEARCH_URL + graficTomorrow.value} alt="grafic" />
                        </Link>
                    }
                    {(graficToday && graficToday?.value?.length > 1) &&
                        <Link target='_blank' to={process.env.REACT_APP_SERVER_SEARCH_URL + graficToday.value}>
                            <img height={265} width={1038} src={process.env.REACT_APP_SERVER_SEARCH_URL + graficToday.value} alt="grafic" />
                        </Link>
                    }
                </div>
                {/* <GroupSerach /> */}
            </div>
            </div>
        </section> 
    )
}

export default GroupPage